import React, { useState } from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IErrorModel } from "../../../types/error/IErrorModel"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "./ModalPopUp"
import { CommonInput } from "./fields/CommonInput"

interface IChangePasswordRequest {
  oldPassword?: string
  newPassword?: string
}
export const PasswordEdit: React.FC<{ visible: boolean; setVisible: (visible: boolean) => void }> = ({
  visible,
  setVisible
}) => {
  const [passwordRequest, setPasswordRequest] = useState<IChangePasswordRequest>()
  const [rePassword, setRePassword] = useState<string | undefined>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()

  const submit = () => {
    if (passwordRequest?.newPassword !== rePassword) {
      setModalMessage({ title: "Ошибка!", text: "Пароли не совпадают" })
      return
    }
    TrinityAPI.changePassword(passwordRequest, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        setErrors(response.data)
        setModalMessage({ title: "Ошибка!", text: "" })
      }
    })
  }

  if (visible) {
    return (
      <>
        <ModalPopUp message={modalMessage} error={errors} close={() => setModalMessage(null)} />
        <section className="popup-forms" id="admin-profile">
          <div className="container-popup-forms">
            <button className="close-btn-card" id="admin-profile-close" onClick={() => setVisible(false)} />
            <div className="popup-card">
              <h4 className="heading-chapter">Изменение пароля</h4>
              <CommonInput
                typeName={"password"}
                label={"Старый пароль"}
                placeholder={"A—a Z—z 1 * / -"}
                name={"oldPassword"}
                value={passwordRequest?.oldPassword}
                errorModel={errors}
                _callback={e => setPasswordRequest({ ...passwordRequest, oldPassword: e })}
              />
              <CommonInput
                typeName={"password"}
                label={"Новый пароль"}
                placeholder={"A—a Z—z 1 * / -"}
                name={"newPassword"}
                value={passwordRequest?.newPassword}
                errorModel={errors}
                _callback={e => setPasswordRequest({ ...passwordRequest, newPassword: e })}
              />
              <CommonInput
                typeName={"password"}
                label={"Повторите новый пароль"}
                placeholder={"A—a Z—z 1 * / -"}
                name={"rePassword"}
                value={rePassword}
                errorModel={errors}
                _callback={e => setRePassword(e)}
              />
              <div className="flex-row-24">
                <button className="btn" onClick={submit}>
                  Сохранить
                </button>
                <button className="btn grey-btn" onClick={() => setVisible(false)}>
                  Отменить
                </button>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  } else {
    return <></>
  }
}
